import { render, staticRenderFns } from "./StockOpnameWarranty.vue?vue&type=template&id=8b540bfc&"
import script from "./StockOpnameWarranty.vue?vue&type=script&lang=js&"
export * from "./StockOpnameWarranty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports